import React from "react";
import JoinRoom from "./JoinRoom";

function App() {
  return (
    <div>
      <JoinRoom />
    </div>
  );
}

export default App;